import React, { useState } from "react";
import { Heart } from "lucide-react";
import ProductImage, { PRODUCT_IMAGE_PLACEHOLDER } from "../common/ProductImage";

export default function ProductDetailGallery({ product, title, discount }) {
  const [selectedImage, setSelectedImage] = useState(0);
  const [saved, setSaved] = useState(false);
  const gallery = Array.isArray(product.images) ? product.images : [];
  const images = gallery.map((image) => typeof image === "string" ? image : image?.image || image?.url).filter(Boolean);
  if (!images.length) images.push(product.image || product.product_image || PRODUCT_IMAGE_PLACEHOLDER);
  const activeImage = Math.min(selectedImage, images.length - 1);
  const visualClass = `productdetail-gallery__visual${product.image_crop === "top" ? " productdetail-gallery__visual--crop" : ""}`;

  return (
    <div className="productdetail-gallery">
      <div className="productdetail-gallery__hero">
        {discount > 0 && <span className="productdetail-gallery__sale">Sale {discount}%</span>}
        <button type="button" className="productdetail-gallery__favourite" aria-label={saved ? "Remove from favourites" : "Save to favourites"} aria-pressed={saved} onClick={() => setSaved((current) => !current)}>
          <Heart size={23} fill={saved ? "currentColor" : "none"} aria-hidden="true" />
        </button>
        <div className={visualClass}>
          <ProductImage src={images[activeImage]} alt={title} fetchPriority="high" />
        </div>
        <span className="visually-hidden" aria-live="polite">Product image {activeImage + 1} of {images.length}</span>
      </div>
      {images.length > 1 && (
        <div className="productdetail-gallery__thumbnails" aria-label="Product images">
          {images.map((image, index) => (
            <button type="button" key={`${image}-${index}`} className={`productdetail-gallery__thumbnail${activeImage === index ? " is-selected" : ""}`} aria-label={`View product image ${index + 1}`} aria-pressed={activeImage === index} onClick={() => setSelectedImage(index)}>
              <div className={visualClass}><ProductImage src={image} alt="" loading="lazy" /></div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
